import { axiosInstance } from "./axiosInstance";
import { logger } from "../utils/logger";
import { parseApiError } from "../types/errors";

export type UserType = "specialist" | "general" | "student" | "enthusiast";

export interface PostRegistrationData {
  userType: UserType;
  workplace?: string;
  specialty?: string;
  experience?: string;
  year?: string;
  university?: string;
  motivation?: string;
}

export interface PostRegistrationResponse {
  success: boolean;
  message: string;
  userId?: string;
}

const postRegistrationService = {
  async savePostRegistrationData(
    data: PostRegistrationData
  ): Promise<PostRegistrationResponse> {
    try {
      logger.info("Saving post-registration data");

      const response = await axiosInstance.post(
        "/profile/post-registration",
        data
      );

      logger.info("Post-registration data saved successfully");

      return {
        success: true,
        message: "Profile information saved successfully",
        userId: response.data.userId,
      };
    } catch (error) {
      const parsedError = parseApiError(error);
      logger.error("Error saving post-registration data");

      throw new Error(
        parsedError.message || "Error saving profile information"
      );
    }
  },

  async checkPostRegistrationStatus(): Promise<{ completed: boolean }> {
    try {
      const response = await axiosInstance.get(
        "/profile/post-registration-status"
      );
      return response.data;
    } catch (error) {
      logger.error("Error checking post-registration status");
      // Si hay error, asumimos que no está completado
      return { completed: false };
    }
  },

  async skipPostRegistration(): Promise<PostRegistrationResponse> {
    try {
      logger.info("User skipped post-registration");

      const response = await axiosInstance.post(
        "/profile/skip-post-registration"
      );

      return {
        success: true,
        message: "Post-registration skipped successfully",
        userId: response.data.userId,
      };
    } catch (error) {
      const parsedError = parseApiError(error);
      logger.error("Error skipping post-registration");

      throw new Error(
        parsedError.message || "Error skipping post-registration"
      );
    }
  },
};

export default postRegistrationService;
